import { V3toVector3, Vector3toV3 } from "@project-rouge/rg-three";
function getObjsDir(startObj, endObj) {
	const start = V3toVector3(startObj.pos);
	return Vector3toV3(V3toVector3(endObj.pos).sub(start).normalize());
}
export { getObjsDir };

//# sourceMappingURL=index99.js.map